export enum UserPreferenceEnum {
  defaultQueue = 'edge-corrections-default-queue',
  buildVersion = 'edge-corrections-build-version',
  topOfStackCache = 'edge-corrections-top-of-stack-cache',
}
